"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _NotifyPopup = require("./NotifyPopup");
Object.keys(_NotifyPopup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NotifyPopup[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NotifyPopup[key];
    }
  });
});
